import {
    LOADALLRETURN,
    LOADRETURN,
    RESETRETURN,
    CHANGERETURNFIELD,
    initialState
} from "../constant/constant";

export default function reducer(state = { ...initialState.payreturn }, action) {

    switch (action.type) {
        case LOADALLRETURN:
            return {...state,payreturns:[...action.payreturn.rows]}
       
        case LOADRETURN:
            return { ...state, payreturn:{...action.payreturn} };
        case CHANGERETURNFIELD:
            return { ...state, payreturn:{...state.payreturn,[action.name]:action.value}};
        case RESETRETURN:
            return {...state,payreturn:{...initialState.payreturn.payreturn}}
        default:
            return { ...state };
    }
}